import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { PipesModule } from '../utility/pipes/pipes.module';
import { StorageLocationsStore } from '../utility/signal-stores/storage-locations.store';
import { PAGE_SIZE_OPTIONS } from '../utility/signal-stores/pagination';
import { ColumnConfig } from '../reusable-components/data-table/column-config';
import { storageLocationColumnConfig } from '../base-data/storage-location/storage-location-table';
import { StorageLocation } from '@knust/api-interfaces';

@Component({
  selector: 'knust-storage-locations',
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    PipesModule,
  ],
  templateUrl: './storage-locations.component.html',
  styleUrl: './storage-locations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorageLocationsComponent {
  protected readonly store = inject(StorageLocationsStore);
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  protected readonly columnConfig: ColumnConfig[] = storageLocationColumnConfig;
  protected readonly displayedColumns = [
    'id',
    'label',
    'address.street',
    'address.zip',
    'address.city',
    'address.country',
  ];
  protected readonly pageSizeOptions = PAGE_SIZE_OPTIONS;

  // Startet mit der letzten Suche, da der Store beim Zurücknavigieren erhalten bleibt
  protected readonly searchTerm = this.store.search;

  protected search(value: string) {
    this.store.setSearch(value);
  }

  protected changePage(event: PageEvent) {
    this.store.setPage(event.pageIndex, event.pageSize);
  }

  protected navigateToArticles(storageLocation: StorageLocation) {
    this.#router.navigate([storageLocation.id], { relativeTo: this.#route });
  }
}
